import { Reveal } from "@/components/Reveal";
import { MANIFESTO, IMAGES } from "@/data/content";

const Manifesto = () => (
    <section id="mission" className="bg-sand py-24 lg:py-32" data-testid="mission-section">
        <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:px-10">
            <div className="lg:col-span-5">
                <Reveal>
                    <p className="text-xs font-medium uppercase tracking-[0.28em] text-saffron">Our Mission</p>
                    <h2 className="mt-4 font-serif text-3xl font-semibold leading-[1.05] tracking-tight text-ink md:text-4xl">
                        The Ganga has carried knowledge for millennia. Now it flows to your home.
                    </h2>
                    <p className="mt-6 text-base leading-relaxed text-muted-foreground md:text-lg">
                        Hindi Ganga Online Classes exists to deliver genuinely high-quality education from India to families
                        worldwide — the same rigour, warmth and patience that built generations of scholars, one live lesson at a time.
                    </p>
                </Reveal>
                <Reveal delay={0.15}>
                    <div className="relative mt-10 overflow-hidden rounded-3xl border border-border bg-cream lift-shadow">
                        <img
                            src={IMAGES.founder}
                            alt="The founder of Hindi Ganga Online Classes"
                            className="aspect-[4/3] w-full object-cover object-top"
                            data-testid="founder-image"
                        />
                        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-teal-dark/90 to-transparent px-6 pb-5 pt-16">
                            <p className="font-serif text-lg font-semibold text-cream">Rashmi Pandey — Founder</p>
                            <p className="mt-0.5 text-xs uppercase tracking-[0.14em] text-cream/75">M.A. Political Science, Jamshedpur Women's College</p>
                            <p className="mt-0.5 text-xs uppercase tracking-[0.14em] text-saffron">7 years of online teaching experience</p>
                        </div>
                    </div>
                </Reveal>
            </div>
            <div className="flex flex-col justify-center gap-10 lg:col-span-7 lg:pl-8" data-testid="manifesto-chapters">
                {MANIFESTO.map((ch, i) => (
                    <Reveal key={ch.number} delay={i * 0.12}>
                        <div className="flex gap-6 border-b border-border pb-10 last:border-0 last:pb-0 lg:gap-10">
                            <span className="font-serif text-4xl font-semibold text-saffron/40 md:text-5xl" data-testid={`manifesto-number-${ch.number}`}>
                                {ch.number}
                            </span>
                            <div>
                                <h3 className="font-serif text-xl font-semibold tracking-tight text-ink md:text-2xl">{ch.title}</h3>
                                <p className="mt-3 max-w-lg text-sm leading-relaxed text-muted-foreground md:text-base">{ch.body}</p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
export default Manifesto;
